import React from "react";
import Page from "../templates/support/childrin&education/spotlight/fare-spectra-school-of-autism";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
